import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { trigger, style, animate, transition } from '@angular/animations';
import { CommonModule } from '@angular/common';

@Component({
  imports: [CommonModule],
  selector: 'app-waiting-module-scoped',
  animations: [
    trigger('waitingAnimation', [
      transition(':enter', [
        style({ opacity: '0' }),
        animate('500ms', style({ opacity: '1' })),
      ]),
      transition(':leave', [
        style({ opacity: '1' }),
        animate('500ms', style({ opacity: '0' })),
      ]),
    ]),
  ],
  templateUrl: './waitingModuleScoped.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./waitingModuleScoped.component.scss'],
})
export class WaitingModuleScopedComponent {
  @Input() localSpinner: boolean = true;
  @Input() noBackdrop: boolean = false;
  @Input() excludeSpinner?: boolean = false;
  @Input() isGlobalSpinner: boolean = false;
}
